<template>
  <div class="tag" @click="$emit('on-remove')">
    <div class="content">
      <p class="name">
        {{ name }} <span>({{ apmid }})</span>
      </p>
    </div>
    <div class="close-icon">
      <Icon size="24" name="times-circle" />
    </div>
  </div>
</template>

<script>
export default {
  name: "UserTag",
  props: {
    name: {
      type: String,
      required: true,
    },
    apmid: {
      type: String,
      required: true,
    },
  },
  methods: {
    onRemove() {
      this.$emit("onRemove");
    },
  },
};
</script>

<style lang="scss" scoped>
.tag {
  display: flex;
  margin-right: 1rem;
  margin-top: 0.75rem;
  background-color: var(--Gray-200);
  border-radius: 0.25rem;
  box-shadow: 0px 1px 2px var(--Gray-100);
  align-items: center;
  cursor: pointer;
  max-width: fit-content;

  &:hover {
    background-color: var(--Gray-400);
  }

  & .content {
    padding: 0.25rem 0.5rem;
    border-right: 1px solid var(--tab-border);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    & .name {
      font-size: 0.75rem;
      color: var(--primary-text);
      font-family: "Maersk Text";
      margin: 0.25rem 0;

      & span {
        font-family: "Maersk Text";
        cursor: pointer;
      }
    }
  }
  & .close-icon {
    margin: 0.25rem 0.5rem;
  }
}
</style>
